import React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/utils/utils";

export type SwitchSize = "sm" | "lg";

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> {
  size?: SwitchSize;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  SwitchProps
>(
  (
    { className, disabled, checked, onCheckedChange, size = "sm", ...props },
    ref
  ) => (
    <SwitchPrimitive.Root
      className={cn(
        "rounded-full group transition-all duration-100 relative outline-none cursor-pointer",
        size === "sm" ? "w-7 h-4" : "w-8 h-5",
        disabled
          ? "bg-border-field-default cursor-not-allowed"
          : "bg-badges-selected",
        !disabled && "group-hover:bg-surface-hover-soft",
        className
      )}
      checked={checked}
      disabled={disabled}
      onCheckedChange={() => onCheckedChange?.(!checked)}
      {...props}
      ref={ref}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "block rounded-full transition-all duration-100 will-change-transform shadow-switch",
          size === "sm" ? "size-[14px]" : "size-[18px]",
          checked ? "translate-x-[13px]" : "translate-x-[1px]",
          disabled
            ? checked
              ? "bg-buttons-cta-primary-2-disabled"
              : "bg-buttons-cta-primary-disabled"
            : checked
              ? "bg-cta group-hover:bg-buttons-toggle-on-hover"
              : "bg-buttons-toggle-off group-hover:bg-buttons-toggle-off-hover"
        )}
      />
    </SwitchPrimitive.Root>
  )
);

Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };
